import { SessionStorageService } from '@nequi/design-system-lib/logic';
import { getKeycloakInstance } from '@shared/utils/keycloak/app.init';
import { KeycloakTokenConfig } from '@shared/utils/keycloak-token/keycloak-token.config';

export const saveTokens = (sessionStorageService: SessionStorageService): void => {
  const keycloak = getKeycloakInstance();
  if (keycloak.token && keycloak.refreshToken) {
    sessionStorageService.setItem(KeycloakTokenConfig.keycloakStorage.kcToken, keycloak.token);
    sessionStorageService.setItem(KeycloakTokenConfig.keycloakStorage.kcRefreshToken, keycloak.refreshToken);
  }
};
